<template>
  <b-form>
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Mostrando</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="pageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>Registros</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="query"
              class="d-inline-block mr-1"
              placeholder="Buscar..."
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <b-table
      ref="refUserListTable"
      class="position-relative"
      :items="items"
      responsive
      :fields="fields"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No se encontraron registros"
    >
      <!-- Column: Actions -->
      <template #cell(add)="row">
        <a
          href="javascript:void(0)"
          title="Editar"
          @click.stop="addPregunta(row.item, 'add')"
        >
          <feather-icon
            icon="PlusCircleIcon"
            class="mr-50 fa-green"
          />
        </a>
      </template>
    </b-table>
  </b-form>
</template>
<script>
import router from '@/router'
import store from '@/store'
import {
  BForm, BRow, BCol, BFormInput, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BTable,
  },
  emits: ['update:is-busy-question', 'update:modal-show'],
  props: {
    typeAction: {
      type: String,
      required: true,
    },
    listQuestion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: '',
      items: [],
      sortBy: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      query: '',
      page: 1,
      fields: [
        { key: 'enunciado', label: 'enunciado', sortable: true },
        { key: 'add', width: '5%' },
      ],
    }
  },
  watch: {
    perPage: {
      handler() {
        this.listarRegistros()
      },
    },
    page: {
      handler() {
        this.listarRegistros()
      },
    },
    query: {
      handler() {
        this.listarRegistros()
      },
    },
  },
  mounted() {
    this.listarRegistros()
  },
  methods: {
    addPregunta(data) {
      this.$emit('update:is-add-new-user-sidebar-active', false)
      this.$emit('update:modal-show', false)
      this.$emit('refresh-data', data)
    },
    listarRegistros() {
      this.isBusy = true
      store
        .dispatch('gsencuesta/PREGUNTA_FIND_ALL', {
          limit: this.perPage,
          query: this.query,
          page: this.page,
          sortBy: 'idPregunta%7CDESC',
          idEncuesta: router.currentRoute.params.id,
        })
        .then(response => {
          this.items = response.items
          this.totalRows = response.totalRows
          this.totalItems = response.totalItems
          this.totalPage = response.totalPage
          this.from = this.perPage * (this.page - 1) + (this.totalRows ? 1 : 0)
          this.to = this.perPage * (this.page - 1) + this.totalRows
          this.of = this.totalItems
        })
        .catch(error => {
          this.$bvToast.tost(error, {
            title: 'Ha ocurrido un error',
            variant: 'danger',
            solid: true,
          })
          this.isBusy = false
        })
    },
  },
}
</script>
